<template>
    <div class="text-container">
        <img class="img" :src="AccessDenied" />
    </div>
</template>
<script setup>
import AccessDenied from '@/assets/access-denied.svg';
</script>
<script>
export default {
    name: 'access-denied',
};
</script>
<style lang="scss">
.text-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
}

.img {
    display: flex;
    justify-content: center;
    vertical-align: middle;
    height: 700px;
}
</style>
